import React from 'react';

import { BVShimmer } from '../../../models/BVShimmers/BVShimmer';

import './bv-shimmer-nav.scss';

interface IBVShimmerNav extends BVShimmer { }

const BVShimmerNav: React.FunctionComponent<IBVShimmerNav> = ({ style }) => (
    <div className="bv-shimmer-nav" style={style}>
        <div className="shimmer-wrapper">
            <div className="shimmer-nav-item">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
            <div className="shimmer-nav-item">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
            <div className="shimmer-nav-item">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
            <div className="shimmer-nav-item">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
            <div className="shimmer-nav-item">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
        </div>
    </div>
);

export default BVShimmerNav;